import { WSPage } from "@wingspanhq/fe-component-library";
import { RouteComponentProps } from "react-router-dom";
import { queriesPayees, queriesRequirements } from "@query";
import { WSQueries } from "../../../../../query/WSQuery";
import { RequirementsDetailsRoute } from "./RequirementsDetailsRoute";
import { useBulkReviewRequirements } from "../../../../BulkReview/hooks/useBulkReviewRequirements";
import { useXWingspanPayerId } from "../useXWingspanPayerId";

export const RouteRequirementDetails: React.FC<
  RouteComponentProps<{
    payeeId: string;
    requirementId: string;
  }>
> = ({
  match: {
    params: { requirementId, payeeId }
  }
}) => {
  const xWingspanAccount = useXWingspanPayerId();
  // The search row carries the server-resolved contractor name the breadcrumb
  // needs, so it replaces the `Payee` read outright.
  // Direct `getPayee`, not the `searchPayeeRows` projection. The search index is
  // currently unstable, and this screen gates its whole render on the read, so a
  // failing index took the page down with it. The child only needs the
  // contractor's id and display name, both of which the entity carries — only
  // the server-resolved `profile.resolvedName` is lost.
  const queryPayee = queriesPayees.getPayee.useQuery(
    { payeeId, xWingspanAccount },
    { staleTime: Infinity }
  );
  const queryRequirement = queriesRequirements.getPayeeRequirement.useQuery(
    { requirementId, xWingspanAccount },
    { staleTime: Infinity }
  );

  useBulkReviewRequirements(requirementId);

  return (
    <WSPage>
      <WSQueries
        queries={{
          queryPayee,
          queryRequirement
        }}
      >
        {({ queryPayeeData, queryRequirementData }) => {
          return (
            <RequirementsDetailsRoute
              payee={queryPayeeData}
              requirement={queryRequirementData}
            />
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
